import styled, { keyframes } from 'styled-components'
import { slowTopAppearWithDelay } from '../../constants/animations'

const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
  iframe {
    animation: ${slowTopAppearWithDelay(40)} ${p => p.theme.duration.l} ease;
    border-radius: 10px;
    z-index: 2;
  }
  &, * {
    box-sizing: border-box;
  }
`

export const shadowAppear = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
`

const Shadow = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  position: fixed;
  z-index: 1;
  opacity: 0.2;
  animation: ${shadowAppear} ${p => p.theme.duration.xl} ease;
`

export const Styled = {
  Container,
  Shadow,
}
